import { ModalProps } from "antd/lib/modal/Modal";
import { Button, Col, Input, message, Modal, Radio, Row, Spin } from "antd";
import Style from "./index.module.scss";
import React, { useContext, useMemo } from "react";
import Form, { useForm } from "rc-field-form";
import "../../../../../style/public.scss";
import ChapterSelect from "../../../../../components/ChapterSelect";
import { Can, errorMessage } from "../../../../../service/service";
import { ResultMessage } from "../../../../../components/ResultMessage";
import FieldWithError from "../../../../../components/FieldWithError";
import { RowProps } from "antd/es/grid";
import {
    addCoursewareSourceForLocalFile,
    AddLocalFileProps,
    LocalFileItemProps
} from "../../../../../service/CourseDetail/resource";
import { CourseContext } from "../../../Store";
import useCurrentDate from "../../../../../utils/useCurrentDate";
import useRequestFn from "../../../../../utils/useRequestFn";
import GoChapter from "../GoChapter";

import Config from "../../../../../config";
import ListItem from "../../../../../components/CourseComponents/Resource/UploadIndicator/components/ListItem";
import classNames from "classnames";
import Description from "../../../../../components/Description";
import { ChapterInfo, FileInfo, PublicInfo } from "../Infos";
import useUploadGen from "../../../../../utils/v2/useUploadGen";
import { CourseWareTypeList } from "../../../../../utils/common";
import FileSelect from "../../../../../components/ChainUpload/Components/FileSelect";

interface DataModalInstance {
    setPayload: (payload: any) => void;
}

interface DataModalProps extends ModalProps {
    onOk?: () => void;
    onCancel?: () => void;
    onSuccess: () => void;
}

const RowAttr: RowProps = {
    gutter: 15,
    type: "flex",
    align: "middle",
    className: Style.row
};

const LocalModal = React.forwardRef<DataModalInstance, DataModalProps>(
    ({ onSuccess, onOk, onCancel, ...props }, ref) => {
        const { cancel, onFileChange, uploadLoading, getFileType, fileList } =
            useUploadGen({});

        const [form] = useForm<AddLocalFileProps>();
        const { course } = useContext(CourseContext);
        const { batchNo } = useCurrentDate();

        const [addAction, { loading }] = useRequestFn(
            addCoursewareSourceForLocalFile
        );
        async function onFinish(data: AddLocalFileProps) {
            try {
                const fileEntityList: LocalFileItemProps[] = fileList
                    .filter(item => item.status === "done")
                    .map(item => {
                        const isVideo = getFileType(item.file.name) === "video";
                        return {
                            fileName: item.file.name,
                            fileSize: item.file.size,
                            fileUrl: isVideo
                                ? item?.response?.key || ""
                                : `${Config.QiNiuDownloadUrlResource}/${item?.response?.key}`
                        };
                    });
                const params: AddLocalFileProps = {
                    batchNo,
                    fileEntityList,
                    courseNo: course.courseNo,
                    courseSeq: course.courseSeq,
                    chapterId: data.chapterId,
                    description: data.description,
                    isDownload: data.isDownload,
                    isPublish: data.isPublish,
                    weektimeId: course.weekTimeId
                };
                await addAction(params).then(res => {
                    message.success("本地添加成功");
                    onSuccess();
                });
            } catch (e) {
                ResultMessage.error(errorMessage(e));
            }
        }

        function beforeCancel() {
            cancel?.();
            onCancel?.();
        }

        const configFileList = useMemo(() => {
            return Object.values(CourseWareTypeList)
                .flat()
                .filter(item => item !== "polyv")
                .join(" / ");
        }, []);

        function pubChange() {
            form.setFieldsValue({ isDownload: Can.no });
        }

        return (
            <Modal
                {...props}
                onCancel={beforeCancel}
                centered
                maskClosable={false}
                title="本地上传"
                onOk={form.submit}
                footer={
                    <div className={Style.footer}>
                        <Button onClick={beforeCancel}>取消</Button>
                        {fileList.length === 0 && (
                            <FileSelect
                                loading={uploadLoading}
                                buttonClass={Style.fileBtn}
                                buttonText="本地上传文件"
                                onFileSelect={onFileChange}
                            />
                        )}
                        {fileList.length > 0 && (
                            <Button
                                type="primary"
                                onClick={form.submit}
                                loading={uploadLoading}>
                                完成
                            </Button>
                        )}
                    </div>
                }>
                <Spin spinning={loading}>
                    <div className={Style.root}>
                        <Form
                            form={form}
                            style={{
                                display: fileList.length > 0 ? "none" : "block"
                            }}
                            onFinish={onFinish}>
                            <Row {...RowAttr}>
                                <Col span={5}>
                                    <div className={Style.label}>
                                        发布设置：
                                    </div>
                                </Col>
                                <Col span={16}>
                                    <FieldWithError
                                        name="isPublish"
                                        initialValue={Can.no}>
                                        <Radio.Group onChange={pubChange}>
                                            <Radio value={Can.no}>
                                                仅上传暂不发布
                                            </Radio>
                                            <Radio value={Can.yes}>
                                                上传并立即发布
                                            </Radio>
                                        </Radio.Group>
                                    </FieldWithError>
                                </Col>
                            </Row>
                            <Row>
                                <Description
                                    className={Style.desc}
                                    content={PublicInfo()}
                                />
                            </Row>
                            <Form.Field dependencies={["isPublish"]}>
                                {(c, m, _form) => {
                                    const _pub =
                                        _form.getFieldValue("isPublish");
                                    return (
                                        <Row {...RowAttr}>
                                            <Col span={5}>
                                                <div className={Style.label}>
                                                    下载设置：
                                                </div>
                                            </Col>
                                            <Col span={16}>
                                                <FieldWithError
                                                    name="isDownload"
                                                    initialValue={_pub}>
                                                    <Radio.Group
                                                        disabled={
                                                            _pub === Can.no
                                                        }>
                                                        <Radio value={Can.no}>
                                                            禁止下载 {}
                                                        </Radio>
                                                        <Radio value={Can.yes}>
                                                            允许下载
                                                        </Radio>
                                                    </Radio.Group>
                                                </FieldWithError>
                                            </Col>
                                        </Row>
                                    );
                                }}
                            </Form.Field>
                            <Row>
                                <Description
                                    className={Style.desc}
                                    content="暂不支持视频下载到本地。"
                                />
                            </Row>
                            <Row {...RowAttr}>
                                <Col span={5}>
                                    <div className={Style.label}>
                                        所属章节：
                                    </div>
                                </Col>
                                <Col span={16}>
                                    <FieldWithError
                                        name="chapterId"
                                        initialValue="0">
                                        <ChapterSelect />
                                    </FieldWithError>
                                </Col>
                                <Col span={1}>
                                    <GoChapter />
                                </Col>
                            </Row>
                            <Row>
                                <Description
                                    className={Style.desc}
                                    content={ChapterInfo()}
                                />
                            </Row>
                            <Row {...RowAttr} align="top">
                                <Col span={5}>
                                    <div
                                        className={classNames(
                                            Style.label,
                                            "label32"
                                        )}>
                                        课件说明：
                                    </div>
                                </Col>
                                <Col span={16}>
                                    <FieldWithError
                                        name="description"
                                        initialValue="">
                                        <Input.TextArea
                                            rows={4}
                                            maxLength={500}
                                            placeholder="输入课件说明，最多500字"
                                        />
                                    </FieldWithError>
                                </Col>
                            </Row>
                            <Row>
                                <Row>
                                    <Description
                                        className={Style.desc}
                                        content={FileInfo(configFileList)}
                                    />
                                </Row>
                            </Row>
                        </Form>
                        {fileList.length > 0 && (
                            <div className={Style.upList}>
                                {Array.from(fileList).map((item: any) => {
                                    return (
                                        <ListItem key={item.uid} file={item} />
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </Spin>
            </Modal>
        );
    }
);

export default LocalModal;
